import styled, { css } from 'styled-components';
import ReactAvatar from 'react-avatar';
import { transparentize } from 'polished';

export interface AvatarProps {
  checked?: boolean;
  name?: string;
  color?: string;
  src?: string;
  size?: string;
  round?: boolean;
  alt?: string;
}

export const CustomAvatar = styled(ReactAvatar)<AvatarProps>`
  position: relative;
  div {
    span {
      color: ${transparentize(0.3, '#fff')};
      font-weight: bold;
    }
  }

  ${props =>
    props.checked &&
    css`
      filter: grayscale(1);
    `}
`;
